export default {
  data() {
    return {
      listSrc: require('@/assets/task.png')
    };
  }
};